import { Pipe, PipeTransform } from '@angular/core';
import { ProcessStatusEnum, ProcessStatusEnumNames, AzureFunctionsService, IProcessStep, IProcess } from '../azurefunctions/azure-functions.service';
import { CompileTemplateMetadata } from '@angular/compiler';



/**
 * Wizrd step class
 */
export class WizardStep implements IProcessStep{
    visible: boolean = true;
    error: any;
    uiFunctionName: string;
    title: string;
    statusDescription: string;
    status: ProcessStatusEnum = ProcessStatusEnum.NotStarted;
    selected: boolean;
    disabled: boolean;

    /**
     * Function that have to be executed for this state
     */
    handler: () => Promise<unknown>;
    /**
     * Function must return parameters for handler
     */
    handlerArgsFunc: () => any;
    /**
     * 
     * @param text step's title
     * @param handler Function that have to be executed for this state
     * @param handlerArgsFunc Function must return parameters for handler
     * 
     * @example
     * new WizardStep([ 
     *   new WizardStep("Set Enterprise Applications owners",  this.functionsService.assignEntAppOwner.bind(this.functionsService), this.getHandlerParams.bind(this))
     * ]);
     */
    
    constructor(){

    }
     
    // constructor(step: IProcessStep, handler: (this: void) => Promise<unknown>, handlerArgsFunc: () => any) {
    //   this.uiFunctionName = id;
    //   this.title = text;
    //   this.handler = handler;
    //   this.handlerArgsFunc = handlerArgsFunc;
    //   this.visible = visisble;
    // }
  
  }


@Pipe({
  name: 'stepHasError',
  pure: false
})
export class WizardStepWithErrorPipe implements PipeTransform {
  transform(items: WizardStep[]): any {
      if (!items) {
          return items;
      }
      // filter items array, items which match and return true will be
      // kept, false will be filtered out
      return items.filter(item => item.status == ProcessStatusEnum.Failed);
  }
}

@Pipe({
  name: 'stepVisible',
  pure: false
})
export class WizardStepVisiblePipe implements PipeTransform {
  transform(items: WizardStep[]): any {
    if (!items) {
      return items;
  }
  // filter items array, items which match and return true will be
  // kept, false will be filtered out
  return items.filter(item => item.visible);
  }
}

/**
 * Wizard implementation
 */
export class Wizard{
  
  steps: WizardStep[];
  currentStepIndex: number = -1;
  started: boolean = false;
  currentProcess: IProcess;

  constructor(name: string, steps: WizardStep[], private functionsService: AzureFunctionsService) {
    
    this.currentProcess = { processName : name, steps: steps, status: ProcessStatusEnum.NotStarted };
    this.steps = steps;
  }

  start(){
    this.functionsService.executePostFunction<string>("RegisterNewProcess", this.steps, {"processName": this.currentProcess.processName} ).toPromise().then((processId) => {
      this.currentProcess.processId = processId;
      this.started = true;
      for(let i=0;i<this.steps.length; i++){
        this.steps[i].status = ProcessStatusEnum.NotStarted;
        this.steps[i].error = null;
      }
      this.currentStepIndex = 0;
      this.executeCurrentStep();
    });
  }

  next(){
    if(this.currentStepIndex < this.steps.length - 1){
      this.currentStepIndex++;
      this.executeCurrentStep();
    }
    else if (this.currentStepIndex == this.steps.length - 1){
     this.complete();
    }
  }

  repeatFailed(){
    for (let i = 0; i < this.steps.length; i++) {
      const element = this.steps[i];
      if(element.status == ProcessStatusEnum.Failed){
        this.currentStepIndex = i;
        break;
      }
    }

    this.executeCurrentStep();
  }

  executeCurrentStep(){
    
    this.currentProcess.status = ProcessStatusEnum.Running;
    this.steps[this.currentStepIndex].status = ProcessStatusEnum.Running;
    this.steps[this.currentStepIndex].error = null;

    this.updateStepStatus(this.steps[this.currentStepIndex]).then(() => {
      var args = this.steps[this.currentStepIndex].handlerArgsFunc == null ? null : this.steps[this.currentStepIndex].handlerArgsFunc.call(null);
      this.steps[this.currentStepIndex].handler.call(null, args).then(
        () => { 
          console.log("Step " + this.currentStepIndex + " complete"); 
          this.steps[this.currentStepIndex].status = ProcessStatusEnum.Completed; 
          
          this.updateStepStatus(this.steps[this.currentStepIndex]).then(() =>this.next());
        },
        (er)=>{ 
          this.currentProcess.status = ProcessStatusEnum.Failed;
          console.error("Step " + this.currentStepIndex + " error: "  + er);
          this.steps[this.currentStepIndex].status = ProcessStatusEnum.Failed; 
          this.steps[this.currentStepIndex].error = er;

          this.updateStepStatus(this.steps[this.currentStepIndex]);
      }
      );
    },
    (er) => {
      console.error("Unable to update step " + this.currentStepIndex + ", error: "  + er);
    })
    
    
  }

  updateStepStatus(step: WizardStep){
    return this.functionsService.executePostFunction("UpdateProcessStepStatus", 
      {status: step.status, statusDescription: JSON.stringify(step.error), stepKey: step.uiFunctionName }, 
      {"processId": this.currentProcess.processId} 
    ).toPromise();
  }

  complete(){
    this.functionsService.executePostFunction<IProcess>("CompleteProcess", {processId: this.currentProcess.processId}, {"processId": this.currentProcess.processId} ).toPromise().then((process) => {
        this.currentProcess = process;
    });
  }

}